import {
	PropsWithChildren,
	ReactElement,
	useEffect,
	useRef,
	RefObject
} from "react";
import { useIntersection } from "client/Hooks/useIntersection";
import { useStableImperativeCallback } from "client/Hooks";

export type IntersectionProps = {
	onEnter: () => void;
	runOnce?: boolean;
};

export const Intersection = (props: PropsWithChildren<IntersectionProps>): ReactElement => {
	const {
		onEnter,
		runOnce,
		children
	} = props;

	const didRunRef: RefObject<boolean> = useRef(false);
	const ref: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement>(null);

	const entry: IntersectionObserverEntry | null = useIntersection(ref);

	const stableOnEnter: typeof onEnter = useStableImperativeCallback(onEnter);

	useEffect(
		() => {
			if (!entry?.isIntersecting) {
				return;
			}

			if (runOnce && didRunRef.current) {
				return;
			}

			stableOnEnter();
			didRunRef.current = true;
		},
		[
			stableOnEnter,
			runOnce,
			entry,
			didRunRef
		]
	);

	return (
		<div ref={ref}>
			{children}
		</div>
	);
};

Intersection.displayName = "Intersection";
